import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_CONFIGURATION_LISTING,
    ADD_CONFIGURATION,
    UPDATE_CONFIGURATION,
    ADD_CONFIGURATION_ITEM,
    UPDATE_CONFIGURATION_ITEM,
    DELETE_CONFIGURATION,
    BULK_DELETE_CONFIGURATION,
    DELETE_CONFIGURATION_ITEM,
    BULK_DELETE_CONFIGURATION_ITEM,
    EXPORT_CONFIGURATION,
    GET_CONFIGURATION_DETAILS,
} from "./actionTypes.js";

import {
    getConfigurationListingSuccess,
    getConfigurationListingFail,
    createConfigurationSuccess,
    createConfigurationFail,
    updateConfigurationSuccess,
    updateConfigurationFail,
    createConfigurationItemSuccess,
    createConfigurationItemFail,
    updateConfigurationItemSuccess,
    updateConfigurationItemFail,
    deleteConfigurationSuccess,
    deleteConfigurationFail,
    bulkDeleteConfigurationSuccess,
    bulkDeleteConfigurationFail,
    deleteConfigurationItemSuccess,
    deleteConfigurationItemFail,
    bulkDeleteConfigurationItemSuccess,
    bulkDeleteConfigurationItemFail,
    exportConfigurationSuccess,
    exportConfigurationFail,
    getConfigurationDetailsSuccess,
    getConfigurationDetailsFail,
} from "./actions.js";

import {
    configurationListingApi,
    updateConfigurationApi,
    updateConfigurationItemApi,
    deleteConfigurationApi,
    deleteConfigurationItemApi,
    bulkDeleteConfigurationApi,
    bulkDeleteConfigurationItemApi,
    exportConfigurationApi,
    configurationDetailsApi,
    addConfigurationApi,
    addConfigurationItemApi,
} from "./configurationApi.js";

function* fetchConfigurationListing({ payload }) {
    try {
        const response = yield call(configurationListingApi, payload);
        yield put(getConfigurationListingSuccess(response));
    } catch (error) {
        yield put(getConfigurationListingFail(error));
    }
}

function* fetchConfigurationDetail({ payload }) {
    try {
        const response = yield call(configurationDetailsApi, payload);
        yield put(getConfigurationDetailsSuccess(response));
    } catch (error) {
        yield put(getConfigurationDetailsFail(error));
    }
}

function* createConfiguration({ payload }) {
    try {
        const response = yield call(addConfigurationApi, payload);
        yield put(createConfigurationSuccess(response));
    } catch (error) {
        yield put(createConfigurationFail(error));
    }
}

function* updateConfiguration({ payload }) {
    try {
        const response = yield call(updateConfigurationApi, payload);
        yield put(updateConfigurationSuccess(response));
    } catch (error) {
        yield put(updateConfigurationFail(error));
    }
}

function* createConfigurationItem({ payload }) {
    try {
        const response = yield call(addConfigurationItemApi, payload);
        yield put(createConfigurationItemSuccess(response));
    } catch (error) {
        yield put(createConfigurationItemFail(error));
    }
}

function* updateConfigurationItem({ payload }) {
    try {
        const response = yield call(updateConfigurationItemApi, payload);
        yield put(updateConfigurationItemSuccess(response));
    } catch (error) {
        yield put(updateConfigurationItemFail(error));
    }
}

function* deleteConfiguration({ payload }) {
    try {
        const response = yield call(deleteConfigurationApi, payload);
        yield put(deleteConfigurationSuccess(response));
    } catch (error) {
        yield put(deleteConfigurationFail(error));
    }
}

function* bulkDeleteConfiguration({ payload }) {
    try {
        const response = yield call(bulkDeleteConfigurationApi, payload);
        yield put(bulkDeleteConfigurationSuccess(response));
    } catch (error) {
        yield put(bulkDeleteConfigurationFail(error));
    }
}

function* deleteConfigurationItem({ payload }) {
    try {
        const response = yield call(deleteConfigurationItemApi, payload);
        yield put(deleteConfigurationItemSuccess(response));
    } catch (error) {
        yield put(deleteConfigurationItemFail(error));
    }
}

function* bulkDeleteConfigurationItem({ payload }) {
    try {
        const response = yield call(bulkDeleteConfigurationItemApi, payload);
        yield put(bulkDeleteConfigurationItemSuccess(response));
    } catch (error) {
        yield put(bulkDeleteConfigurationItemFail(error));
    }
}

function* exportConfiguration({ payload }) {
    try {
        const response = yield call(exportConfigurationApi, payload);
        yield put(exportConfigurationSuccess(response));
    } catch (error) {
        yield put(exportConfigurationFail(error));
    }
}

function* ConfigurationSaga() {
    yield takeEvery(GET_CONFIGURATION_LISTING, fetchConfigurationListing);
    yield takeEvery(GET_CONFIGURATION_DETAILS, fetchConfigurationDetail);
    yield takeEvery(ADD_CONFIGURATION, createConfiguration);
    yield takeEvery(UPDATE_CONFIGURATION, updateConfiguration);
    yield takeEvery(ADD_CONFIGURATION_ITEM, createConfigurationItem);
    yield takeEvery(UPDATE_CONFIGURATION_ITEM, updateConfigurationItem);
    yield takeEvery(DELETE_CONFIGURATION, deleteConfiguration);
    yield takeEvery(BULK_DELETE_CONFIGURATION, bulkDeleteConfiguration);
    yield takeEvery(DELETE_CONFIGURATION_ITEM, deleteConfigurationItem);
    yield takeEvery(BULK_DELETE_CONFIGURATION_ITEM, bulkDeleteConfigurationItem);
    yield takeEvery(EXPORT_CONFIGURATION, exportConfiguration);

}

export default ConfigurationSaga
